// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer-content[data-v-2a68ca18]{display:flex;justify-content:center;align-items:center;flex-wrap:wrap;padding:40px 20px;background:#2e323b;font-size:14px;line-height:14px;font-weight:400;color:#e2e2e2;text-align:center}.footer-content a[data-v-2a68ca18]{color:#e2e2e2}.footer-content p[data-v-2a68ca18]{width:100%;padding:10px;text-align:center}@media only screen and (max-width:768px){.footer-content[data-v-2a68ca18]{padding:30px 15px}}", ""]);
// Exports
module.exports = exports;
